const BackBtnMob = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="38.5" height="38.5" rx="19.25" stroke="white" strokeWidth="1.5"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M18.7752 14.5581C19.0193 14.8021 19.0193 15.1979 18.7752 15.4419L14.8421 19.375H26.6666C27.0118 19.375 27.2916 19.6548 27.2916 20C27.2916 20.3452 27.0118 20.625 26.6666 20.625H14.8421L18.7752 24.5581C19.0193 24.8021 19.0193 25.1979 18.7752 25.4419C18.5311 25.686 18.1354 25.686 17.8913 25.4419L12.8913 20.4419C12.6472 20.1979 12.6472 19.8021 12.8913 19.5581L17.8913 14.5581C18.1354 14.314 18.5311 14.314 18.7752 14.5581Z" fill="white"/>
        </svg>

    )
}

export default BackBtnMob